import { useState } from 'react';
import Button from '../../buttons/Button';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import LoadingPanel from '../../LoadingPanel';
import CoraError from '../../utils/coraError';
import withMeta from '../../utils/withMeta';
import { buildUrl } from '../../utils/helper';

/**
 * Akcia na odblokovanie zablokovaného konta používateľa (61)
 * @param {object} props 
 * @returns 
 */
const OdblokUz = ({ primaryField, selected, showMsg, obj, db, meta }) => {
  const akcInfo = obj?.akc;
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleConfirm = async () => {
    handleClose();
    setIsLoading(true);
    try {
      const res = await meta.odblokUz(selected[0]?.IUz, db);
      if (res?.Data === true) {
        showMsg(`Konto používateľa ${selected[0]?.NUz} bolo úspešne odblokované`);
      } else {
        showMsg(`Konto používateľa ${selected[0]?.NUz} sa nepodarilo odblokovať`, "warning");
      }
      await obj.onGetList();
    } catch (error) {
      if (error instanceof CoraError) {
        showMsg(error.message, "error");
      } else {
        showMsg(`Nepodarilo sa odblokovať konto používateľa ${selected[0]?.NUz}.`, "error");
      }
    }
    setIsLoading(false);
  };

  const isZablok = selected && selected.length === 1 && selected[0]?.LZablok;

  return (
    <>
      <Button
        onClick={handleOpen}
        title={akcInfo?.NAkc ?? "Odblokovanie zablokovaného konta"}
        imageUrl={buildUrl('assets/icons/toolbar/unlocked.svg')}
        disabled={!isZablok ||selected?.length !== 1 || akcInfo?.Disabled}
      />
      <ConfirmDialog
        isOpen={isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        text={`Odblokovať konto používateľa ${selected[0]?.NUz ?? ""}?`}
        confirmText="Áno"
        cancelText="Nie"
      />
      <LoadingPanel isLoading={isLoading} />
    </>
  );
};

export default withMeta(OdblokUz);